export const ExpandIcon = ({ expanded }: { expanded?: boolean }) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)'
    }}
  >
    <path
      d="M10.579 1.26401L6.4126 4.79932L2.24616 1.26401C1.82736 0.908659 1.15085 0.908659 0.732063 1.26401C0.313271 1.61937 0.313271 2.1934 0.732063 2.54875L5.66092 6.73098C6.07971 7.08634 6.75622 7.08634 7.17502 6.73098L12.1039 2.54875C12.5227 2.1934 12.5227 1.61937 12.1039 1.26401C11.6851 0.917771 10.9978 0.908659 10.579 1.26401Z"
      fill="#C0C0C4"
    />
  </svg>
);
